export default __webpack_public_path__ + "static/media/Ballroll_00082.ab96e7be.png";